import { render, staticRenderFns } from "./ProductLimitRules.vue?vue&type=template&id=367b52a5"
import script from "./ProductLimitRules.vue?vue&type=script&lang=js"
export * from "./ProductLimitRules.vue?vue&type=script&lang=js"
import style0 from "./ProductLimitRules.vue?vue&type=style&index=0&id=367b52a5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports